import { modalAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);

const baseStyle = definePartsStyle({
  overlay: {
    bg: 'backgrounds.overlay',
  },
  dialog: {
    borderRadius: 'lg',
  },
  closeButton: {
    color: 'text.faded',
    fontSize: 'l',
  },
  header: {
    borderBottom: 'section',
  },
  body: {
    borderRadius: 'dialogerBodyRadius',
    backgroundColor: 'table.footer',
  },
});

export const Modal = defineMultiStyleConfig({
  baseStyle,
});
